import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.16675 0.666656H4.00008C2.15925 0.666656 0.666748 2.15916 0.666748 3.99999V14C0.666748 15.8408 2.15925 17.3333 4.00008 17.3333H14.0001C15.8409 17.3333 17.3334 15.8408 17.3334 14C17.3334 12.1075 17.3334 9.83332 17.3334 9.83332C17.3334 9.37332 16.9601 8.99999 16.5001 8.99999C16.0401 8.99999 15.6667 9.37332 15.6667 9.83332V14C15.6667 14.92 14.9201 15.6667 14.0001 15.6667C11.2251 15.6667 6.77425 15.6667 4.00008 15.6667C3.07925 15.6667 2.33341 14.92 2.33341 14C2.33341 11.225 2.33341 6.77416 2.33341 3.99999C2.33341 3.07916 3.07925 2.33332 4.00008 2.33332H8.16675C8.62675 2.33332 9.00008 1.95999 9.00008 1.49999C9.00008 1.03999 8.62675 0.666656 8.16675 0.666656ZM14.4884 2.33332H11.5001C11.0401 2.33332 10.6667 1.95999 10.6667 1.49999C10.6667 1.03999 11.0401 0.666656 11.5001 0.666656H16.5001C16.9601 0.666656 17.3334 1.03999 17.3334 1.49999V6.49999C17.3334 6.95999 16.9601 7.33332 16.5001 7.33332C16.0401 7.33332 15.6667 6.95999 15.6667 6.49999V3.51166L9.58925 9.58916C9.26425 9.91416 8.73591 9.91416 8.41091 9.58916C8.08508 9.26416 8.08508 8.73582 8.41091 8.41082L14.4884 2.33332Z"
      fill="#FB6514"
    />
  </svg>
);

export default SvgComponent;
